import { Toggle } from "../../js/extensions";

export default class Accordion extends Toggle {
  constructor(el) {
    super({
      el,
      toggleClass: "c-accordion--active",
    });
    this.initEvents();
  }

  initEvents() {
    this.el.removeEventListener("click", (e) => this.handleClick(e));
    this.el.addEventListener("click", (e) => this.handleClick(e));
  }

  handleClick(e = {}) {
    super.toggle();
    if (super.isToggled()) {
      super.enable();
    } else {
      super.disable();
    }
  }
}
